// Copyright (c) Docugami, Inc. All rights reserved.
import { DOMParser } from '@xmldom/xmldom'
// import { StringBuilder } from 'utils/StringBuilder';

/*eslint-disable */

// Note: the following const have eslint-disable because they form the whole of the Open-Xml-Sdk for JavaScript API.
// Most modules will use only a subset of the API, but disabling portions of the API leads to friction when writing
// code.  Disabling eslint for these variables removes the error indicating that a variable is assigned a value but
// never used.  If we ever re-write these modules in TypeScript, then the public API will change significantly.

const Enumerable = require("../../../../../utils/linq");
const Ltxml = require('../../../../../utils/ltxml.js');
Ltxml.DOMParser = DOMParser

const openXml = require('../../../../../utils/openxml');

const XAttribute = Ltxml.XAttribute;
const XCData = Ltxml.XCData;
const XComment = Ltxml.XComment;
const XContainer = Ltxml.XContainer;
const XDeclaration = Ltxml.XDeclaration;
const XDocument = Ltxml.XDocument;
const XElement = Ltxml.XElement;
const XName = Ltxml.XName;
const XNamespace = Ltxml.XNamespace;
const XNode = Ltxml.XNode;
const XObject = Ltxml.XObject;
const XProcessingInstruction = Ltxml.XProcessingInstruction;
const XText = Ltxml.XText;
const XEntity = Ltxml.XEntity;
const cast = Ltxml.cast;
const castInt = Ltxml.castInt;

const W = openXml.W;
const W14 = openXml.W14;
const W15 = openXml.W15;
const NN = openXml.NoNamespace;
const wNs = openXml.wNs;
const FLATOPC = openXml.FLATOPC;
const groupAdjacent = openXml.groupAdjacent;
/*eslint-enable */

export function transformWmlToDgml(wmlDocument: any): any
{
    var newContent = doTransform(wmlDocument);

    return newContent;
}

class DG
{
    public static dg: any = new XNamespace('http://www.docugami.com/2021/dgml');
    public static chunk: any = new XName(DG.dg + 'chunk');
}

function doTransform(wmlDocument: any): any
{
    const body = wmlDocument.descendants(W.body).firstOrDefault();

    const numberingPart = wmlDocument.elements(FLATOPC.part).first((p: any) => p.attribute(FLATOPC.contentType)?.value === openXml.contentTypes.numberingDefinitions);
    const numberingDefinitionsRootElement = numberingPart.element(FLATOPC.xmlData).element(W.numbering)

    const cleanedUpBody = cleanUp(body);
    const newContent = wmlToDgmlTransform(cleanedUpBody, numberingDefinitionsRootElement);

    // let str = cleanedUpBody.value;

    // let newContent: any = new XElement(DG.chunk,
    //     new XAttribute(XNamespace.xmlns + "dg", 'http://www.docugami.com/2021/dgml'),
    //     new XAttribute('structure', 'p'),
    //     str);

    return newContent;
}


function wmlToDgmlTransform(node: any, numberingDefinitionsRootElement: any)
{
    const element = node;

    if (element.nodeType === 'Element')
    {
        if (element.name === W.body)
        {
            const bodyChunk = new XElement(DG.chunk,
                new XAttribute(XNamespace.xmlns + "dg", 'http://www.docugami.com/2021/dgml'),
                new XAttribute('structure', 'div'),
                transformBodyElement(element, numberingDefinitionsRootElement));
            return bodyChunk;
        }

        if (element.name === W.p)
        {
            const paraText = element.value;
            const paraChunk = new XElement(DG.chunk,
                new XAttribute('structure', 'p'),
                paraText);
            return paraChunk;
        }

        if (element.name === W.tbl)
        {
            const tableChunk = tableTransform(element, numberingDefinitionsRootElement);
            return tableChunk;
        }

        if (element.name === W.tcPr)
        {
            return null;
        }

        return new XElement(element.name,
            element.attributes(),
            element.nodes().select((n: any) => wmlToDgmlTransform(n, numberingDefinitionsRootElement)));
    }
    return node;
}

function transformBodyElement(body: any, numberingDefinitionsRootElement: any): any
{
    const paragraphsArray = body
        .elements()
        .where((e: any) => e.name === W.p || e.name === W.tbl)
        .toArray();

    const grouped = groupAdjacent(paragraphsArray, (t: any) => {
        // get the num ID, else return -1
        const pPr = t.element(W.pPr);
        let groupKey: number = -1;
        if (!!pPr)
        {
            const numPr = pPr.element(W.numPr);
            if (!!numPr)
            {
                const numId = numPr.element(W.numId);
                if (!!numId)
                {
                    groupKey = Number(numId.attribute(W.val).value);
                }
            }
        }
        return groupKey;
    });

    const newBodyContent: any[] = [];
    for (let i = 0; i < grouped.length; ++i) {
        const likeParagraphs = grouped[i];
        const key = likeParagraphs.Key;

        // if key === -1, then iterate through everything in the group, generating content.
        if (key === -1)
        {
            likeParagraphs.Group.forEach((p: any) =>
            {
                const paraChunk = wmlToDgmlTransform(p, numberingDefinitionsRootElement)
                newBodyContent.push(paraChunk);
            });
        }
        else
        {
            // if key !== -1, then determine the list-style-type, then generate the ol/ul, and li for everything in the group.
            const [listType, listStyleType] = getListStyleType(key, numberingDefinitionsRootElement);
            const list: any = new XElement(DG.chunk,
                new XAttribute('structure', listType),
                new XAttribute('style', `list-style-type: ${listStyleType}`),
                likeParagraphs.Group.select((p: any) =>
                {
                    const listParaChunk = new XElement(DG.chunk,
                        new XAttribute('structure', 'li'),
                        wmlToDgmlTransform(p, numberingDefinitionsRootElement));
                    return listParaChunk;
                }).toArray()
                );

            newBodyContent.push(list);
        }

    }
    return newBodyContent;
}

function getListStyleType(key: number, numberingDefinitionsRootElement: any)
{
    const num: any = numberingDefinitionsRootElement
        .elements(W.num)
        .firstOrDefault((z: any) =>
        {
            const numId = Number(z.attribute(W.numId).value);
            return numId === key;
        });

    if (!!num)
    {
        const abstractNumIdElement = num.element(W.abstractNumId);
        if (!!abstractNumIdElement)
        {
            const abstractNumId = Number(abstractNumIdElement.attribute(W.val).value);
            const abstractNum = numberingDefinitionsRootElement
                .elements(W.abstractNum)
                .firstOrDefault((z: any) =>
                {
                    const numId = Number(z.attribute(W.abstractNumId).value);
                    return numId === abstractNumId;
                });
            const firstLvl = abstractNum.element(W.lvl);
            if (!!firstLvl)
            {
                const numFmt = firstLvl.element(W.numFmt);
                if (!!numFmt)
                {
                    const val = numFmt.attribute(W.val).value;
                    if (val === "decimal")
                    {
                        return ["ol", "decimal"] as const;
                    }
                    if (val === "upperLetter")
                    {
                        return ["ol", "upper-alpha"] as const;
                    }
                    if (val === "lowerLetter")
                    {
                        return ["ol", "lower-alpha"] as const;
                    }
                    if (val === "upperRoman")
                    {
                        return ["ol", "upper-roman"] as const;
                    }
                    if (val === "lowerRoman")
                    {
                        return ["ol", "lower-roman"] as const;
                    }
                    if (val === "bullet")
                    {
                        return ["ul", "circle"] as const;
                    }
                }
            }
        }
    }
    return ["ol", "decimal"] as const;
}

function cleanUp(node: any) {
    const element = node;
    if (element.nodeType === 'Element')
    {
        if (element.name === W.instrText)
        {
            return null;
        }

        return new XElement(element.name,
            element.attributes(),
            element.nodes().select((n: any) => cleanUp(n)));
    }
    if (node.nodeType === 'Text' && node.value.trim() === "")
    {
        return null;
    }
    return node;
}

function tableTransform(element: any, numberingDefinitionsRootElement: any)
{
    const table: any = new XElement(DG.chunk,
        new XAttribute('structure', "table"),
        new XElement(DG.chunk,
            new XAttribute('structure', 'tbody'),
                element.elements(W.tr).select((tr: any) =>
                {
                    return new XElement(DG.chunk,
                        new XAttribute('structure', 'tr'),
                        tr.elements(W.tc).select((tc: any) =>
                        {
                            let colspanAtt: any = null;
                            const tcPr: any = tc.element(W.tcPr);
                            if (!!tcPr)
                            {
                                const vMerge = tcPr.element(W.vMerge);
                                if (!!vMerge)
                                {
                                    const val = vMerge.attribute(W.val);
                                    if (!val)
                                    {
                                        // need to nuke this cell - it is just a placeholder for vertically merged cells.
                                        return null;
                                    }
                                }

                                const gridSpan: any = tcPr.element(W.gridSpan);
                                if (!!gridSpan)
                                {
                                    const colSpanVal = Number(gridSpan.attribute(W.val).value);
                                    colspanAtt = new XAttribute('colspan', colSpanVal);
                                }
                            }

                            let rowspanAtt: any = determineRowspanAtt(tc);

                            return new XElement(DG.chunk,
                                new XAttribute('structure', 'td'),
                                colspanAtt,
                                rowspanAtt,
                                tc.nodes().select((n: any) => wmlToDgmlTransform(n, numberingDefinitionsRootElement)));
                        }))
                })));
    return table;
}

function determineRowspanAtt(tc: any): any
{
    const tcPr = tc.element(W.tcPr);
    if (!!tcPr)
    {
        const vMerge = tcPr.element(W.vMerge);
        if (!!vMerge)
        {
            const val = vMerge.attribute(W.val);
            if (!!val && val.value === 'restart')
            {
                // need to count the number of cells in this vMerge and return a rowspan attribute with that number
                const cellsBeforeThisCell = tc.elementsBeforeSelf().count();
                let rowspanCount = 1;
                let currentRow = tc.parent;
                while (true)
                {
                    currentRow = currentRow.elementsAfterSelf().firstOrDefault();
                    if (!currentRow)
                    {
                        break;
                    }
                    const cellToLookAt = currentRow.elements().skip(cellsBeforeThisCell).firstOrDefault();
                    if (!cellToLookAt)
                    {
                        break;
                    }
                    const ctla_tcPr = cellToLookAt.element(W.tcPr);
                    if (!ctla_tcPr)
                    {
                        break;
                    }
                    const ctla_vMerge = ctla_tcPr.element(W.vMerge);
                    if (!ctla_vMerge)
                    {
                        break;
                    }
                    const ctla_val = ctla_vMerge.attribute(W.val);
                    if (!!ctla_val && ctla_val.value === 'restart')
                    {
                        break;
                    }
                    if (!ctla_val)
                    {
                        rowspanCount++;
                        continue;
                    }
                    break;
                }
                const rowspanAtt = new XAttribute('rowspan', rowspanCount);
                return rowspanAtt;
            }

            return null;
        }
    }
    return null;
}
